<template lang="pug">
  input(:value="value" @input="onSelected($event.target.value)" :placeholder="placeholder")
</template>
<script>
import Flatpickr from 'flatpickr'

require('flatpickr/dist/flatpickr.css')

export default {
  props: {
    value: null,
    timePicker: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Select a date'
    }
  },
  mounted() {
    this.flatpickr = new Flatpickr(this.$el, {
      enableTime: this.timePicker,
      dateFormat: this.timePicker ? 'Y-m-dTH:i' : 'Y-m-d',
      altInput: true,
      altFormat: this.timePicker ? 'Y/m/d, H:i' : 'Y/m/d',
      allowInput: true,
      time_24hr: true,
      defaultDate: this.value
    })
  },
  beforeDestroy() {
    this.flatpickr.destroy()
  },
  watch: {
    value() {
      if (this.flatpickr) {
        this.flatpickr.setDate(this.value)
      }
    }
  },
  methods: {
    onSelected(val) {
      const date = new Date(val)
      this.$emit('input', date)
    }
  },
  components: {
    Flatpickr
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Datepicker.vue